import { render, staticRenderFns } from "./ClinicCampaigns.vue?vue&type=template&id=4ddeb760"
import script from "./ClinicCampaigns.vue?vue&type=script&lang=js"
export * from "./ClinicCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports